// @ts-nocheck

import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { KNOWLEDGE_BASE_TYPE_OPTIONS } from '@/utilities/constant';
import { AI_NAME_MAX_LENGTH } from '@/utilities/aiAgentsStore';

export default function EditKnowledgeBaseDialog({ open, onOpenChange, row, onSave }: any) {
  const [name, setName] = useState('');
  const [kbType, setKbType] = useState(KNOWLEDGE_BASE_TYPE_OPTIONS[0]?.value || 'general');
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (row) {
      setName(row.name ?? row.kb_name ?? '');
      setKbType(row.kb_type ?? row.type ?? KNOWLEDGE_BASE_TYPE_OPTIONS[0]?.value ?? 'general');
      setErrors({});
    }
  }, [row]);

  const handleSave = () => {
    if (!name.trim()) {
      setErrors({ name: 'Name is required' });
      return;
    }
    if (name.trim().length > AI_NAME_MAX_LENGTH) {
      setErrors({ name: `Name must be ${AI_NAME_MAX_LENGTH} characters or fewer` });
      return;
    }
    onSave?.({ ...row, name: name.trim(), kb_type: kbType });
    toast.info('Updated locally. This service has no edit/update API yet, so nothing was sent to the server.');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Knowledge Base</DialogTitle>
          <DialogDescription>
            No update endpoint exists on the Knowledge Base service yet — changes here are
            local only and won&apos;t be saved to the server.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="edit-kb-name">
              Name <span className="text-destructive">*</span>
            </Label>
            <Input
              id="edit-kb-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={AI_NAME_MAX_LENGTH}
            />
            <div className="flex items-start justify-between gap-2">
              {errors.name ? <p className="text-xs text-destructive">{errors.name}</p> : <span />}
              <p className="shrink-0 text-xs text-muted-foreground">
                {name.length}/{AI_NAME_MAX_LENGTH}
              </p>
            </div>
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="edit-kb-type">Type</Label>
            <Select value={kbType} onValueChange={setKbType}>
              <SelectTrigger id="edit-kb-type">
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
              <SelectContent>
                {KNOWLEDGE_BASE_TYPE_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
